import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
	header: {
		home:"HOME",
		Classes:"COURSES",
		Camps:"CAMPS",
		Community:"COMMUNITY",
		Calendar:"CALENDAR",
		Teachers:"TEACHERS",
		About:"ABOUT US",
		Cart:"CART",
		login:"LOGIN",
		success:"completed",
		check:"Please select the course you want to enroll",
		FAQ:"FAQ",
		DASHBOARD:"DASHBOARD",
		input:"input",
		select:"select",
		LOGOUT:"LOGOUT",
		confirm_delete:"Are you sure you want to exit?",
		confirm_del:"Are you sure to delete?",
		del_success:"Deleted",
		tips:"Tips",
		resetPassword:"Your password has been reset",
		go_cart:"Go to Cart",
		continue:"Continue Shopping",
		upload_success:'Upload Successfully',
	},
	index:{
		no_data:"There's no data",
		promotion:'Promotions',
		learn:'Learning Centers',
		video:'Videos',
		news:'News',
		events:'Events',
		user_name:'Username',
		password:'password',
		p1:'Forgot password?',
		p2:'Enter your username or email address and we will send you a link to reset your password.',
		p3:'Reset Password',
		FORGOT:'FORGOT PASSWORD',
		RESET:'RESET PASSWORD',
		Back:'Back',
		categories:'Class Categories',
		enter:'Enter the class name here ...',
		view:'Search',
		content:'Send Content',
		success:'Send Success',
		action:'Action',
	},
	footer:{
		Copyright:"Copyright © 2021 Able2Shine.  All Rights Reserved.",
	},
	navleft:{
		dashboard:"Dashboard",
		course:"Course including Long Term Private",
		camp:"Camps",
		private:"One-Time Private Class",
		orders:"Orders",
		orders_camps:"Camp Orders",
		account:"Password",
		friend:"Refer a Friend",
		credits:"Tuition Credits",
		child:"Students Information",
		virtual:"Virtual Class",
		information:"Information Center",
		leave:"Leave function",
		edit:"Setting",
		read:"All Read",
		working_time:"Time Sheet",
		private_classes:"Open time slots",
		availability:"Availability Form",
	},
	member_courses:{
		syllabus:'Course Name',
		course:'Course Schedule',
		get_into:'Enter',
		Reset:'Reset',
		Search_bon:'Search',
		ok:'Confirm',
	},
	member_index:{
		form:'Dashboard',
		calendar:'Calendar',
		syllabus:'Course Name',
		teacher:'Teacher',
		date:'Date',
		course:'Course Schedule',
		student:'Student',
		children_status:'Student State',
		status0:'No roll call',
		status1:'Arrived',
		status2:'Not arrived',
	},
	index_login:{
		h1:'Sign in to continue',
		h2:'Not a member yet? ',
		h3:'Register now',
		h4:'Teacher login',
		username:'Username',
		password:'Password',
		login:'LOGIN NOW',
		forgot:'Forgot Password',
	},
	virtual:{
		list:'Class No.',
		mail:'Mail',
		teacher_news:'Chat with Teacher',
		comment:'Comment',
		task:'Task',
		hair_task:'Assign Homework',
		upload_task:'Submit Homework',
		batch_task:'Check Homework',
		course_assess:'Evaluation Form',
		course_assess_history:'Class Evaluation history',
		certificate:'Certificate',
		feedback:'Feedback',
		feedback_history:'Feedback history',
		on:'No.',
		time:'Time',
		course:'Course',
		status:'Status',
		leave:'Absent Request',
		signin:'Sign In',
		course_name:'Course Name',
		teacher_name:"Teacher’s Name",
		course_time:'Course Time',
		course_status:'Course Status',
		leave_history:'Absence Record',
		del:'Delete',
		edit:'Edit',
		return:'Return',
		all:'All',
		unread:'Unread',
		read:'Read',
		unread_quantity:'Unread Messages',
		teachers_index:'Take Roll',
		teachers_index_history:'Attendance Record',
		teachers_task:'Task',
		teachers_parent:'Chat with Parents',
		teachers_letter:'Announcement',
		teachers_letter_history:'Announcement Record',
		teachers_assess:'Evaluation Form',
		teachers_certificate:'Certificate',
		teachers_leave:'Request Time off',
		operation:'Action',
		select:'Select all',
		student:'Student',
		parent:'Parent',
		submit:'Submit',
		class_size:'Class Size',
		course_today:"Today's course",
		arrived_num:'Number of Student Attended',
		not_arrived_num:'Number of Student Absent',
		name:'Name',
		content:'Content',
		file_upload:'File Upload',
		add_file:'Add File',
		file:'File',
		upload:'Upload',
		download:'Download',
		time:'Time',
		reason:'Reason',
		letter_type:'Type',
		children_id:'Select Student',
		send:'Send',
		score:'Score',
		assessment:'Evaluation Form',
		debate_assessment:'Debate Evaluation Form',
		issue_certificate:'Issue Certificate',
		notes:"notes draft",
		upload_video:'Upload File(FileSize < 20MB)',
		upload_link:'File Link(FileSize > 20MB)',
		ok:'OK',
		student_name:'Student Name',
		p_tishi:'*Upload File(FileSize < 20MB) or Use File Link',
		sound:'Sound Recording',
		recording_upload:'Recording Upload',
		duration:'Recording Duration',
		play_duration:'Playback Duration',
		start_recording:'Start Recording',
		re_record:'Re-record',
		suspend_recording:'Suspend Recording',
		continue_recording:'Continue Recording',
		stop_recording:'Stop Recording',
		play_recording:'Play Recording',
		pause_playback:'Pause Playback',
		continue_playing:'Continue Playing',
		stop_playing:'Stop Playing',
		cancel:'Cancel',
		recording_error:'The page needs to access your microphone. Please set it up before proceeding.',
		not_written:"The student hasn't submitted the homework yet.",
		teacher_tips:'Please select a student to start chatting.',
		upload_succeeded:'Upload Succeeded',
		link:'Google Link',
		download:'Preview',
		zoom:'Zoom Link',
		center_name:'Site',
		user_tel:'Parent Phone',
		grade:'Grade',
		age:'Age',
		fields:'Custom Fields',
        trial_substitute:'Trial/make-up class',
        trial_listening:'trial listening',
        substitute:'make up a missed lesson',
        remark:'remark',
        evaluation:'Evaluation Form',
	},
	assess:{
		title:'Listening, Speaking, Reading & Writing / Comprehensive Programs for Empowering Youth Confidence & Leadership / Lights, Camera, Action!',
		student:"Student's name",
		teacher:"Teacher's name",
		class:'Class Level',
		location:'Class Location',
		time:'Class Day & Time',
		session:'Session',
		notes:"Teacher's Notes",
		table_statistics:'Evaluation Form Statistics',
		sound:'Teacher Recording',
	},
	student:{
		name:'Name',
		status:'Status',
		reason:'Reason',
		date:'Date',
		teacher:'Teacher',
		operator:'Operator',
		reject:'Reject',
	},
	working_time:{
		course:'Course',
		class_num:'Total Classes',
		should:'The Evaluation Form No.',
		already:'Evaluation Form Completed',
	},
	member_account:{
		confirm:'Save',
		old_password:'Old Password',
		new_password:'New Password',
		confirm_password:'Confirm Password',
		rules_old:'Please enter the old password',
		rules_new:'Please enter a new password',
		rules_confirm:'inconsistent passwords',
	},
	private_classes:{
		course_time:'Regular Class Time',
		course_date:'Class Time',
		course_name:'Class Name',
		private_free_date:'Add private class free time',
		time_length:'Duration',
		rest_time:'Break Time',
		start_time:'Start Time',
		end_time:'End Time',
		all:'All available class hours',
		sold:'Courses Sold',
        purchased:'Purchased',
        confirmed:'Confirmed',
        cannot_delete:'It has been sold and cannot be deleted',
        free_time:'Free Time',
        end_date:'End Date',
        type:'Type',
        week:'Week',
        week:'Week',
        confirm_delete:'Confirm Delete',
        batch_add:'Batch add',
	},
	debate:{
		add:'Add evaluation',
		date:'Valuation Date',
		view:'View',
		del:'Delete',
	},
	...enLocale
}
export default en;


// WEBPACK FOOTER //
// ./src/i18n/langs/en.js